// Changelog data - curated user-facing features only
// Filtered from git commits to hide technical details

export const changelogData = [
  {
    date: "2025-01-20",
    title: "Recent Updates & Quality Improvements",
    changes: [
      "Enhanced mockup quality with improved AI processing",
      "Added scroll-to-top functionality for better navigation",
      "Fixed update cards padding consistency (24px everywhere)",
      "Improved calendar icon alignment in update cards",
      "Reduced bullet point size for better visual hierarchy"
    ]
  },
  {
    date: "2025-01-19",
    title: "Subscription Billing & Pricing Updates",
    changes: [
      "Added monthly and annual subscription options",
      "Enhanced mockup quality with 20% monthly discount",
      "Implemented 40% annual discount for better value",
      "Updated Stripe integration for recurring billing",
      "Enhanced mockup quality across all subscription tiers"
    ]
  },
  {
    date: "2025-01-18",
    title: "UI/UX Improvements & Quality Enhancement",
    changes: [
      "Enhanced mockup quality with better image processing",
      "Fixed responsive layout issues on tablet and mobile",
      "Improved hero section centering and image scaling",
      "Enhanced mockup quality in card stack display",
      "Better visual feedback and user experience"
    ]
  },
  {
    date: "2025-10-20",
    title: "UI Improvements & Image Enhancement",
    changes: [
      "Added image upscaling to 2K and 4K resolution",
      "Improved header design with transparency effects",
      "Enhanced thumbnail display with larger previews",
      "Better visual feedback during generation",
      "Enhanced mockup quality with improved processing"
    ]
  },
  {
    date: "2025-10-19",
    title: "New Style Categories",
    changes: [
      "Added 8 new style options: Car, Bar, Restaurant, Skatepark, Duck, Rave, Garage, Store",
      "Added 3 city-themed styles: Paris, NYC, Tokyo",
      "Renamed Coffee style to Café",
      "Added custom color picker for personalized backgrounds",
      "Enhanced mockup quality with improved style matching"
    ]
  },
  {
    date: "2025-10-17",
    title: "Enhanced Mockup Quality",
    changes: [
      "Improved screen content preservation in all mockups",
      "Better device detection and positioning",
      "Enhanced style intelligence for automatic selection"
    ]
  },
  {
    date: "2025-10-16",
    title: "Pricing & Credits System",
    changes: [
      "Introduced credit-based pricing system",
      "Added flexible credit packs: 5, 15, 50, 200, 800 credits",
      "Updated pricing page with new credit options",
      "Improved payment flow integration",
      "Enhanced mockup quality for all credit tiers"
    ]
  },
  {
    date: "2025-10-13",
    title: "Dark Mode Support",
    changes: [
      "Added comprehensive dark mode throughout the app",
      "Improved visual contrast and readability",
      "Enhanced user experience in low-light conditions",
      "Enhanced mockup quality with better dark mode rendering"
    ]
  },
  {
    date: "2025-10-10",
    title: "Landing Page & User Experience",
    changes: [
      "Added transformation showcase with before/after examples",
      "Improved landing page with new sections",
      "Enhanced cookie consent management",
      "Better mobile responsiveness"
    ]
  },
  {
    date: "2025-10-09",
    title: "Core Features & Authentication",
    changes: [
      "Added user authentication with Google sign-in",
      "Implemented mockup deletion functionality",
      "Added bokeh background enhancement feature",
      "Improved Safari browser compatibility",
      "Added profile picture support"
    ]
  },
  {
    date: "2025-10-02",
    title: "Payment Integration",
    changes: [
      "Integrated Stripe payment processing",
      "Added Pro plan subscription option",
      "Implemented secure checkout flow",
      "Added notification system for user feedback"
    ]
  },
  {
    date: "2025-10-01",
    title: "User Management & Storage",
    changes: [
      "Added Firebase user authentication",
      "Implemented cloud storage for mockups",
      "Added user account management",
      "Enhanced data persistence and security"
    ]
  },
  {
    date: "2025-09-30",
    title: "Initial Launch",
    changes: [
      "Launched RandomMockups with device detection",
      "Added multiple mockup style categories",
      "Implemented image generation with AI",
      "Created responsive web interface"
    ]
  }
];

export default changelogData;
